module.exports = __webpack_public_path__ + "img/hy1.0d82b4cc.png";